import { datadogRum } from '@datadog/browser-rum';

import { internalAxios } from '@/helpers/http/internalAxiosClient';

import { getAuthToken } from '../Authentication/authClient';
import { ListingStats } from './types';

export const getListingStats = async (listingId: string): Promise<ListingStats | null> => {
  try {
    const authToken = await getAuthToken();

    if (!authToken) {
      return null;
    }

    const response = await internalAxios.get(
      `${import.meta.env.VUE_TENANT_PLUS_API_ENDPOINT}/listingStatistics?ids=${listingId}`,
      {
        headers: {
          Authorization: `Bearer ${authToken}`,
        },
      },
    );
    const listingStats: ListingStats[] = response.data;

    return listingStats[0];
  } catch (error) {
    if (error.response?.status !== 401) {
      datadogRum.addError(error);
    }
    return null;
  }
};
